import { onClickOutside } from '@vueuse/core'
import { isFunction, isObject, isEqual } from 'vessel/utils'

const onMounted = (el, binding, vnode) => {
  onUnmounted(el)

  let value = binding.value

  if (!isObject(value)) {
    value = { handler: value }
  }

  const { handler, options } = value

  if (isFunction(handler)) {
    el.stopClickAway = onClickOutside(
      el, handler.bind(vnode.context), options
    )
  }
}

const onUnmounted = (el) => {
  if (el.stopClickAway) {
    try {
      el.stopClickAway()
    } finally {
      delete el.stopClickAway
    }
  }
}

const onUpdated = (el, binding, vnode) => {
  if (!isEqual(binding.value, binding.oldValue)) {
    onMounted(el, binding, vnode)
  }
}

const Plugin = {
  install(Vue) {
    Vue.directive('click-away', {
      bind: onMounted,
      update: onUpdated,
      unbind: onUnmounted
    })
  }
}

export default Plugin
